var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.1956C17.5228 22.1956 22 17.7184 22 12.1956C22 6.67271 17.5228 2.19556 12 2.19556C6.47715 2.19556 2 6.67271 2 12.1956C2 17.7184 6.47715 22.1956 12 22.1956Z",
    stroke: "#585A5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08984 9.19555C9.32495 8.52722 9.789 7.96366 10.3998 7.60469C11.0106 7.24571 11.7287 7.11449 12.427 7.23427C13.1253 7.35404 13.7587 7.71708 14.2149 8.25908C14.6712 8.80109 14.9209 9.48708 14.9198 10.1956C14.9198 12.1956 11.9198 13.1956 11.9198 13.1956",
    stroke: "#585A5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.1956H12.01",
    stroke: "#585A5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/helpCircle.dd740c5d8b29c58bbd77c95b4333fa66.svg";
export { ForwardRef as ReactComponent };